const numberFormat = window.Spark.number_format;

module.exports = {
	path: '/configurator',
	component: require('@views/QuoteBuilder').default,
	name: 'builder',
	props: true,
	meta: {
		showButton: false,
		title: 'Products',
		icon: ['far', 'cogs'],
		primary: true,
		search: {
			placeholder: 'Search Quotes',
			show: false,
		},
	},

	children: [
		{
			path: `/configurator/:number(${numberFormat})?`,
			component: require('@views/quote-builder/StepOne').default,
			props: true,
			meta: {
				title: 'Select Product',
				progress: 0,
				in_privacy: true,
				step: 1,
			},
		},
		{
			path: `/configurator/:number(${numberFormat})/customize/:line_item`,
			component: require('@views/quote-builder/StepThree').default,
			props: (route) => {
				return Object.assign({}, route.params,{ edit: true });
			},
			meta: {
				navigation: false,
				title: 'Customize',
				progress: 40,
				in_privacy: true,
				step: 3,
			},
		},
		{
			path: `/configurator/:number(${numberFormat})/review`,
			component: require('@views/quote-builder/StepFour').default,
			props: true,
			meta: {
				title: 'Review & Prep',
				progress: 60,
				in_privacy: true,
				step: 4,
				needs_line_items: true,
			},
		},
		{
			path: `/configurator/:number(${numberFormat})/summary`,
			component: require('@views/quote-builder/StepFive').default,
			props: true,
			meta: {
				title: 'Complete Quote',
				progress: 80,
				in_privacy: true,
				step: 5,
				needs_line_items: true,
			},
		},
		{
			path: `/orders/:number(${numberFormat})`,
			component: require('@views/quote-builder/StepSix').default,
			props: true,
			meta: {
				title: 'Order',
				progress: 100,
				in_privacy: true,
				step: 6,
			},
		},
		{
			path: `/configurator/:number(${numberFormat})/:category`,
			component: require('@views/quote-builder/StepTwo').default,
			props: true,
			meta: {
				title: 'Choose Model',
				progress: 20,
				in_privacy: true,
				step: 2,
				needs_category: true,
			},
		},
		{
			path: `/configurator/:number(${numberFormat})/:category/:sku`,
			component: require('@views/quote-builder/StepThree').default,
			props: true,
			meta: {
				title: 'Customize',
				progress: 40,
				in_privacy: true,
				step: 3,
				needs_category: true,
				needs_sku: true,
				alternative_url: `/configurator/:number(${numberFormat})/customize/:line_item`
			},
		},
	],
};
